import React, { forwardRef, type Ref } from 'react';
import { InputNumber as AntdInputNumber } from 'antd';
import type { InputNumberProps } from 'antd/lib/input-number';
import cn from 'classnames';

export const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>(({ className = '', ...restProps }, ref) => {
    return <AntdInputNumber ref={ref as Ref<HTMLInputElement>} className={cn('mi', className)} {...restProps} />;
});

InputNumber.displayName = 'InputNumber';
